import { render } from "./domTable.vue?vue&type=template&id=1c1f98ec"
import script from "./domTable.vue?vue&type=script&lang=js"
export * from "./domTable.vue?vue&type=script&lang=js"

import "./domTable.vue?vue&type=style&index=0&id=1c1f98ec&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__